import type { FC, PropsWithChildren, ReactNode } from 'react';
import {
    CardGroup,
    Col,
    MatchMedia,
    Row,
    SecondaryNavigation,
} from '@george-labs.com/design-system';

import { useActiveMenuItem } from '@shared/products-core';
import { t } from '@luna/i18n';

import type { NavigationProps } from './LayoutProps';
import styles from './MainLayout.module.scss';

type Props = NavigationProps & { layoutProductInfo: ReactNode };

export const LayoutWithSideMenu: FC<PropsWithChildren<Props>> = ({
    navigationItems,
    layoutProductInfo,
    children,
}) => {
    const activeMenuItem = useActiveMenuItem();

    return (
        <Row>
            <Col lg={3}>
                <MatchMedia min={MatchMedia.TIER.LG}>
                    <SecondaryNavigation
                        featuredCard={
                            <CardGroup className="mt-0 mb-3">{layoutProductInfo}</CardGroup>
                        }
                        items={navigationItems}
                        className={styles.secondaryNavigation}
                        id="side-menu"
                        data-cy="side-menu"
                        selectedItem={activeMenuItem}
                        aria-label={t('main.sideMenu.navigationA11yLabel')}
                    />
                    <div
                        id="anchor-nav"
                        className={`${styles['anchor-navigation']} ml-auto mr-1`}
                    />
                </MatchMedia>
            </Col>
            <Col lg={9}>
                <main>{children}</main>
            </Col>
        </Row>
    );
};
